import { render } from "./GradeFinalization.vue?vue&type=template&id=43d2daa8&scoped=true"
import script from "./GradeFinalization.vue?vue&type=script&lang=js"
export * from "./GradeFinalization.vue?vue&type=script&lang=js"

import "./GradeFinalization.vue?vue&type=style&index=0&id=43d2daa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d2daa8"]])

export default __exports__